import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { action, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';

class ModalErrosEnvioLotePje extends ReactComponent {
    handleClose = () => {
        this.observableProps.onClose(false);
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            handleClose: action
        });
    }

    render() {
        return (
            <Dialog
                open={this.observableProps.open}
                maxWidth="md"
                fullWidth={true}
                onClose={this.handleClose}
            >
                <DialogTitle
                    id="simple-dialog-title"
                    style={{ color: '#b71c1c' }}
                >
                    Erros no envio de Processos ao PJe
                </DialogTitle>
                <DialogContent style={{ overflowY: 'hidden', padding: '0px' }}>
                    {this.salaSessaoStore.mensagemErroEnvioLote.length > 0 &&
                        this.salaSessaoStore.mensagemErroEnvioLote.map((mensagem) => {
                            return (
                                <div
                                    key={this.nextKey}
                                    style={{ marginLeft: '25px', fontSize: '11pt' }}
                                >
                                    {mensagem}
                                </div>
                            );
                        })}
                    {this.salaSessaoStore.quantidadeErroMovimento > 0 && (
                        <div style={{ marginTop: '10px', marginLeft: '25px', fontSize: '13pt', fontWeight: 'bold' }}>
                            Total de processos com erro no envio de MOVIMENTOS:{' '}
                            {this.salaSessaoStore.quantidadeErroMovimento}
                        </div>
                    )}
                    {this.salaSessaoStore.quantidadeErroCertidao > 0 && (
                        <div style={{ marginTop: '10px', marginLeft: '25px', fontSize: '13pt', fontWeight: 'bold' }}>
                            Total de processos com erro no envio de CERTIDÕES:{' '}
                            {this.salaSessaoStore.quantidadeErroCertidao}
                        </div>
                    )}
                    {this.salaSessaoStore.quantidadeErroAcordao > 0 && (
                        <div style={{ marginTop: '10px', marginLeft: '25px', fontSize: '13pt', fontWeight: 'bold' }}>
                            Total de processos com erro no envio de ACÓRDÃOS:{' '}
                            {this.salaSessaoStore.quantidadeErroAcordao}
                        </div>
                    )}
                </DialogContent>
                <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button
                        onClick={this.handleClose}
                        color="secondary"
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default inject('stores')(observer(ModalErrosEnvioLotePje));
